/**
 * useIsFinePointer — detect desktop + mouse environment.
 *
 * Used to gate expensive cursor-driven effects (3D tilt, magnetic CTAs,
 * cursor-parallax) on Desktop-with-mouse only. Touch screens just get the
 * static editorial layout.
 *
 * Reactive: returns true once and re-evaluates if the user attaches a mouse
 * later (e.g. iPad with magic keyboard).
 */
import { useEffect, useState } from "react";

export const useIsFinePointer = () => {
  const get = () =>
    typeof window !== "undefined" &&
    window.matchMedia?.("(min-width: 768px) and (pointer: fine)").matches;

  const [fine, setFine] = useState(get);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia("(min-width: 768px) and (pointer: fine)");
    const onChange = () => setFine(mq.matches);
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, []);

  return fine;
};

export default useIsFinePointer;
